<template>
  <f7-page name="device-check" ref="page">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back"></f7-nav-left>
      <f7-nav-title sliding>{{ $t('DeviceCheck') }}</f7-nav-title>
      <f7-nav-right></f7-nav-right>
    </f7-navbar>
    <f7-progressbar v-if="isLoading" infinite color="green" class="progressbar-top"></f7-progressbar>

    <f7-block>
      <p>{{$t('CheckDeviceDescription')}}</p>
    </f7-block>

    <f7-list>
      <f7-list-item :title="$t('Position')" link="#" @click="sendCommandPosition">
        <template #media>
          <f7-icon icon="f7-icons text-color-lightgray icon-position"></f7-icon>
        </template>
      </f7-list-item>
      <f7-list-item :title="$t('Settings')" link="#" @click="sendCommandSettings">
        <template #media>
          <f7-icon icon="f7-icons text-color-lightgray icon-details"></f7-icon>
        </template>
      </f7-list-item>
      <f7-list-item :title="$t('Status')" link="#" @click="sendCommandStatus">
        <template #media>
          <f7-icon icon="f7-icons text-color-lightgray icon-other-imei"></f7-icon>
        </template>
      </f7-list-item>

      <f7-list-item>
        <span>Notifications</span>
        <f7-toggle @change="notificationsOn" v-model:checked="notificationsState"></f7-toggle>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapGetters } from "vuex";
import { QTAPI } from "../../services/qt-api";
import { f7 } from "framework7-vue";

export default {
  name: "device-check",
  data() {
    return {
      isLoading: false,
      notificationsState: true
    };
  },
  computed: {
    ...mapGetters(["MajorToken", "MinorToken", "TargetAsset"])
  },
  watch: {
    notificationsState() {
      console.log(this.TargetAsset);
    }
  },
  methods: {
    async notificationsOn() {
      var mobileToken = !localStorage.PUSH_MOBILE_TOKEN
        ? "123"
        : localStorage.PUSH_MOBILE_TOKEN;
      var appKey = !localStorage.PUSH_APP_KEY
        ? "123"
        : localStorage.PUSH_APP_KEY;
      var deviceType = !localStorage.DEVICE_TYPE
        ? "webapp"
        : localStorage.DEVICE_TYPE;
      var deviceToken = !localStorage.PUSH_DEVICE_TOKEN
        ? "123"
        : localStorage.PUSH_DEVICE_TOKEN;

      var data = {
        IMEI: this.TargetAsset.IMEI,
        MinorToken: this.MinorToken,
        MobileToken: mobileToken,
        AppKey: appKey,
        Token: deviceToken,
        Type: deviceType
      };

      if (this.notificationsState) {
        data.State = 0;
      } else {
        data.State = 1;
      }

      this.isLoading = true;
      let result = await QTAPI.ChangeNotificationStatus(data);
      this.isLoading = false;
      if (!result) {
        return;
      }
      f7.notification
        .create({
          subtitle: this.$t("Success"),
          text: this.$t("SetNewState")
        })
        .open();
    },
    async sendCommandPosition() {
      this.isLoading = true;
      let response = await QTAPI.SimSendCommand({
        IMSI: this.TargetAsset.SimNO,
        SMSType: "Query_Position"
      });
      this.isLoading = false;
      if (!response) {
        return;
      }
      /*let result = await QTAPI.SendCommandPosition({
        MinorToken: this.MajorToken,

        IMEI: this.TargetAsset.IMEI,

        MobileToken: localStorage.PUSH_MOBILE_TOKEN,
        AppKey: localStorage.PUSH_APP_KEY,
        Token: localStorage.PUSH_DEVICE_TOKEN,
        Type: localStorage.DEVICE_TYPE
      });*/
      f7.notification
        .create({
          subtitle: this.$t("Success"),
          text: this.$t("CommandSent")
        })
        .open();
      this.$store.dispatch("GetCreditBalance");
    },
    async sendCommandSettings() {
      this.isLoading = true;
      /*let result = await QTAPI.SendCommandConfig({
        MinorToken: this.MajorToken,

        IMEI: this.TargetAsset.IMEI,

        MobileToken: localStorage.PUSH_MOBILE_TOKEN,
        AppKey: localStorage.PUSH_APP_KEY,
        Token: localStorage.PUSH_DEVICE_TOKEN,
        Type: localStorage.DEVICE_TYPE
      });*/
      let response = await QTAPI.SimSendCommand({
        IMSI: this.TargetAsset.SimNO,
        SMSType: "Query_Settings"
      });
      this.isLoading = false;
      if (!result) {
        return;
      }
      f7.notification
        .create({
          subtitle: this.$t("Success"),
          text: this.$t("CommandSent")
        })
        .open();
      this.$store.dispatch("GetCreditBalance");
    },
    async sendCommandStatus() {
      this.isLoading = true;
      /*let result = await QTAPI.SendCommandStatus({
        MinorToken: this.MajorToken,

        IMEI: this.TargetAsset.IMEI,

        MobileToken: localStorage.PUSH_MOBILE_TOKEN,
        AppKey: localStorage.PUSH_APP_KEY,
        Token: localStorage.PUSH_DEVICE_TOKEN,
        Type: localStorage.DEVICE_TYPE
      });*/
      let response = await QTAPI.SimSendCommand({
        IMSI: this.TargetAsset.SimNO,
        SMSType: "Query_Status"
      });
      this.isLoading = false;
      if (!result) {
        return;
      }
      f7.notification
        .create({
          subtitle: this.$t("Success"),
          text: this.$t("CommandSent")
        })
        .open();
      this.$store.dispatch("GetCreditBalance");
    }
  }
};
</script>

<style scoped>
</style>